/**
 * Rails' CSRF token, for the handful of places that reach the server with
 * `fetch` rather than an Inertia visit (a live pre-screen, the raccoon's
 * memory, the Hackatime picker). Inertia sets this header itself.
 */
export function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";
}
